/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};

;// CONCATENATED MODULE: ./src/ts/entrypoint/store-opening/StoreOpening.ts
class StoreOpening {
    constructor() {
        this.hours = null;
        this.closedToken = 'FERME';
        this.closedLabel = 'Fermé';
        this.locale = document.documentElement.lang || 'en-EN';
    }
    init() {
        const hoursData = this.getHoursData();
        const i18nData = this.getI18nData();
        if (!hoursData) {
            return;
        }
        this.hours = hoursData;
        if (i18nData) {
            if (i18nData.closedToken)
                this.closedToken = i18nData.closedToken;
            if (i18nData.closedLabel)
                this.closedLabel = i18nData.closedLabel;
        }
        this.displayHours();
    }
    getHoursData() {
        const script = document.querySelector('script[data-variant-store]');
        if (!(script === null || script === void 0 ? void 0 : script.textContent))
            return null;
        try {
            return JSON.parse(script.textContent);
        }
        catch (error) {
            console.error('Erreur JSON horaires:', error);
            return null;
        }
    }
    getI18nData() {
        const script = document.querySelector('script[data-hours-i18n]');
        if (!(script === null || script === void 0 ? void 0 : script.textContent))
            return null;
        try {
            return JSON.parse(script.textContent);
        }
        catch (error) {
            console.warn('Erreur JSON i18n:', error);
            return null;
        }
    }
    displayHours() {
        const container = document.querySelector('[data-hours-block]');
        const list = container === null || container === void 0 ? void 0 : container.querySelector('.spa-detail__hours');
        if (!list || !this.hours)
            return;
        list.innerHTML = '';
        const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
        days.forEach((day, index) => {
            var _a, _b;
            const start = (_a = this.hours) === null || _a === void 0 ? void 0 : _a[`${day}Start`];
            const end = (_b = this.hours) === null || _b === void 0 ? void 0 : _b[`${day}End`];
            if (!start && !end)
                return;
            const dayName = this.getDayName(index);
            const timeRange = this.formatTimeRange(start, end);
            if (!timeRange)
                return;
            const li = document.createElement('li');
            li.className = 'spa-detail__hours-row';
            const labelSpan = document.createElement('span');
            labelSpan.className = 'spa-detail__hours-label';
            labelSpan.textContent = dayName;
            const valueSpan = document.createElement('span');
            valueSpan.className = 'spa-detail__hours-value';
            valueSpan.textContent = timeRange;
            li.appendChild(labelSpan);
            li.appendChild(valueSpan);
            list.appendChild(li);
        });
    }
    getDayName(dayIndex) {
        const date = new Date(2024, 0, 1 + dayIndex);
        const formatter = new Intl.DateTimeFormat(this.locale, { weekday: 'long' });
        const name = formatter.format(date);
        return name.charAt(0).toUpperCase() + name.slice(1);
    }
    formatTimeRange(start, end) {
        if (this.isClosed(start) || this.isClosed(end)) {
            return this.closedLabel;
        }
        if (start && end && this.isTime(start) && this.isTime(end)) {
            return `${this.formatTime(start)} - ${this.formatTime(end)}`;
        }
        if (start && this.isTime(start))
            return this.formatTime(start);
        if (end && this.isTime(end))
            return this.formatTime(end);
        return start || end || '';
    }
    isTime(value) {
        if (!value)
            return false;
        return /^\d{1,2}:\d{2}$/.test(value.trim());
    }
    isClosed(value) {
        if (!value)
            return false;
        return value.trim().toUpperCase() === this.closedToken.toUpperCase();
    }
    formatTime(time) {
        const [hours, minutes] = time.split(':');
        const h = Number(hours);
        const m = Number(minutes);
        if (isNaN(h) || isNaN(m))
            return time;
        if (this.locale.toLowerCase().startsWith('fr')) {
            return m === 0 ? `${h}h` : `${h}h${minutes}`;
        }
        const date = new Date();
        date.setHours(h, m, 0, 0);
        const formatter = new Intl.DateTimeFormat(this.locale, {
            hour: 'numeric',
            minute: '2-digit',
        });
        return formatter.format(date);
    }
}
/* harmony default export */ var store_opening_StoreOpening = ((/* unused pure expression or super */ null && (StoreOpening)));

;// CONCATENATED MODULE: ./src/ts/entrypoint/store-opening/index.ts

document.addEventListener('DOMContentLoaded', () => {
    const storeOpening = new StoreOpening();
    storeOpening.init();
});

/******/ })()
;